import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=e89808e2&scoped=true&"
import script from "./FileInput.vue?vue&type=script&lang=js&"
export * from "./FileInput.vue?vue&type=script&lang=js&"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=e89808e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89808e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VTextarea})
